module.exports = __webpack_public_path__ + "img/fenxi.8a63765f.png";